import _get from 'lodash/get'; // Readers

import departmentReader from '../readers/Department'; // Constants

import DEPARTMENT_TYPES from 'tbase/constants/departmentTypes';

var getDepartmentTypeName = function getDepartmentTypeName(department) {
  var departmentType = departmentReader.departmentType(department);

  var departmentTypeName = _get(DEPARTMENT_TYPES, "".concat(departmentType, ".name"));

  return departmentTypeName;
};

var getDepartmentLabel = function getDepartmentLabel(department) {
  var showDepartmentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var departmentName = departmentReader.name(department);
  var departmentCode = departmentReader.departmentCode(department);
  var departmentType = getDepartmentTypeName(department);

  if (!departmentCode && !departmentName) {
    return departmentReader.id(department);
  }

  var departmentLabel = "".concat(departmentCode, " - ").concat(departmentName);

  if (departmentType && showDepartmentType) {
    departmentLabel = "".concat(departmentLabel, " (").concat(departmentType, ")");
  }

  return departmentLabel;
};

export default getDepartmentLabel;